import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

import './BorrowingTitle.scss';


export default function BorrowingTitle({ headingKey, taglineKey }) {
  return (
    <div className="cp-borrowing-title">
      <FormattedMessage id={headingKey}>
        {(message) => <h1 className="page-heading">{message}</h1>}
      </FormattedMessage>
      {taglineKey && <FormattedMessage id={taglineKey}>
        {(message) => <p className="tagline">{message}</p>}
      </FormattedMessage>}
    </div>
  );
}

BorrowingTitle.propTypes = {
  headingKey: PropTypes.string.isRequired,
  taglineKey: PropTypes.string
};




// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingTitle/BorrowingTitle.jsx